import BlockSelectField from '@common/components/FormElements/BlockSelectField';
import React from 'react';

const optionsForPerTimeRange = (options) =>
  options.map((option, index) => ({
    label: `${option?.startTime?.substr(0, 5)} - ${option?.endTime?.substr(0, 5)}`,
    value: index,
  }));

export const PerTimeRange = ({ field, options }) => {
  return (
    <BlockSelectField
      onChange={(value) => {
        field.onChange(value);
      }}
      value={field.value}
      options={optionsForPerTimeRange(options)}
    />
  );
};
